module.exports = __webpack_public_path__ + "media/images/resources-thumbnail-9286abc6.png";